const ROLE_I18N_KEYS = {
  'Super Admin': 'user_form_role_super_admin',
  admin: 'user_form_role_admin',
  Admin: 'user_form_role_admin',
  Employee: 'user_form_role_employee',
  employee: 'user_form_role_employee',
}

const ROLE_DEFAULT_LABELS = {
  'Super Admin': 'Super Admin',
  admin: 'Admin',
  Admin: 'Admin',
  Employee: 'Employee',
  employee: 'Employee',
}

export function getUserRoleLabel(user, formatMessage) {
  if (user?.super_admin) {
    return formatMessage({
      id: 'user_form_role_super_admin',
      defaultMessage: 'Super Admin',
    })
  }

  const role = user?.roles?.[0]
  if (!role) {
    return formatMessage({
      id: 'user_form_role_admin',
      defaultMessage: 'Admin',
    })
  }

  const roleName = role.display_name || role.name || ''
  const i18nKey = ROLE_I18N_KEYS[roleName]

  if (i18nKey) {
    return formatMessage({
      id: i18nKey,
      defaultMessage: ROLE_DEFAULT_LABELS[roleName] || role.display_name || roleName,
    })
  }

  return role.display_name || roleName
}

export function getUserRoleNames(user) {
  const roles = user?.roles || []
  return roles.map((role) => String(role?.name || '').toLowerCase()).filter(Boolean)
}

export function userHasRole(user, roleName) {
  const target = String(roleName || '').toLowerCase()
  if (!target) return false
  return getUserRoleNames(user).includes(target)
}

/**
 * @param {object} user
 * @param {{ allow?: string[], deny?: string[] }} [access]
 * @returns {boolean}
 */
export function userMatchesRoleAccess(user, access = {}) {
  const allow = access.allow || []
  const deny = access.deny || []
  if (deny.length && deny.some((role) => userHasRole(user, role))) return false
  if (!allow.length) return true
  return allow.some((role) => userHasRole(user, role))
}

export function isEmployeeUser(user) {
  return userHasRole(user, 'employee')
}

export function isAdminUser(user) {
  return userHasRole(user, 'admin')
}
